import { createFormInstance } from "@js/forms/components/create-form-instance";

import type { AcceptJobOfferAddress } from "../../types";

export type AcceptOfferFormData = {
  address: AcceptJobOfferAddress | null;
  contract_terms_accepted_at?: string;
};

export const AcceptOfferFormInstance = createFormInstance<
  AcceptOfferFormData,
  unknown
>("accept-offer");
